import { IconButton } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { observer } from 'mobx-react-lite';
import { useLoginService } from '../../../services/loginService';
import styles from './index.module.scss';

const BackButton = () => {
  const { state } = useLoginService();

  if ((!state.forgotPassword.value || state.forgotPassword.state) && !state.loginWithSso.value) {
    return null;
  }

  return (
    <IconButton
      className={styles.backBtn}
      onClick={() => state.resetLoginStates()}>
      <ArrowBackIosNewIcon />
    </IconButton>
  );
};
export default observer(BackButton);
